import { useEffect } from 'react'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '864611220016529'

/**
 * Loads the Meta Pixel script and fires a PageView event once on mount.
 * Safe to call multiple times — the script will only be injected once.
 */
export function useMetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    // Standard Meta Pixel base code (inlined as a function for safety in SPA)
    if (!window.fbq) {
      const n: any = (window.fbq = function () {
        // eslint-disable-next-line prefer-rest-params
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!window._fbq) window._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      // Append to <head> (or fall back to <body>) — robust regardless of
      // whether any other <script> tags exist at effect time (e.g. in
      // sandboxed iframes the script list can be empty).
      const target = document.head || document.body
      if (target) {
        target.appendChild(script)
      }
    }

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')

    // <noscript> fallback img — for users with JS disabled / crawlers
    if (!document.getElementById('meta-pixel-noscript')) {
      const noscript = document.createElement('noscript')
      noscript.id = 'meta-pixel-noscript'
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
      noscript.appendChild(img)
      document.body.appendChild(noscript)
    }
  }, [])
}
